import { draftConst } from 'store/constants/draftConst';

export const updateNewFeaturesDraftAction = newFeature => ({
  type: draftConst.UPDATE_NEW_FEATURES_DRAFT,
  newFeature,
});
